import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';
import { color, pattern, mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import actions from '../../actions';
import Modal from '../Modal/Modal';
import InputBase from '../Input/Input';
import { withCreateInvoice } from '../../model/Mutations';

const Container = styled.div`
  text-align: center;
`;

const Title = styled.div`
  margin-bottom: 16px;
  font-size: 20px;
`;

const Subtitle = styled.div`
  margin-bottom: 24px;
  color: ${color.text.title};
`;

const Input = styled(InputBase)`
  width: 100%;
  padding: 10px 16px;
  line-height: 1;
  border-radius: 4px;
  font-size: 20px;
  letter-spacing: 10px;
  text-align: center;
`;

const Helper = styled.div`
  margin: 12px auto 50px;
  color: ${color.text.error};
  visibility: ${props => (props.active ? 'visable' : 'hidden')};
`;

class InvoiceModal extends React.Component {
  state = {
    carrierId: '',
    submitting: false,
    printing: false,
  };

  onInputChange = e => {
    e.preventDefault();

    const { value } = e.target;

    if (_.size(value) > 8) return;

    this.setState({ carrierId: _.toUpper(value) });
  };

  onCodeSubmit = e => {
    e.preventDefault();

    this.setState({ submitting: true }, async () => {
      await this.onSend({
        successMessage: '已歸戶',
        carrierId: this.state.carrierId,
      });

      this.setState({ submitting: false });
    });
  };

  onInvoicePrint = e => {
    e.preventDefault();

    this.setState({ printing: true }, async () => {
      await this.onSend({ successMessage: '已列印' });

      this.setState({ printing: false });
    });
  };

  onSend = async ({ carrierId, successMessage }) => {
    const { onInvoiceCreate, editStatus, toggle } = this.props;
    const payload = await onInvoiceCreate({ carrierId });

    if (!payload) return;

    editStatus(successMessage);
    toggle();
  };

  get error() {
    const { carrierId } = this.state;

    return _.size(carrierId) === 8 && !pattern.carrier_id.test(carrierId);
  }

  get isInvoiceSubmitted() {
    return Boolean(_.size(this.props.invoice.status));
  }

  render() {
    const { carrierId, submitting, printing } = this.state;
    const {
      invoice: { active },
      toggle,
    } = this.props;

    return (
      <Modal
        active={active}
        onToggleModal={toggle}
        actions={{
          save: {
            text: '列印電子發票證明聯',
            callback: this.onInvoicePrint,
            loading: printing,
            disabled: this.isInvoiceSubmitted,
          },
          option: {
            text: '輸入載具號碼',
            callback: this.onCodeSubmit,
            loading: submitting,
            disabled:
              this.error || _.size(carrierId) < 8 || this.isInvoiceSubmitted,
          },
        }}
      >
        <Container>
          <Title>電子載具</Title>
          <Subtitle>掃描手機條碼或輸入載具號碼</Subtitle>
          <Input
            value={carrierId}
            onChange={this.onInputChange}
            disabled={this.isInvoiceSubmitted}
          />
          <Helper active={this.error}>條碼格式不正確，請重新輸入</Helper>
        </Container>
      </Modal>
    );
  }
}

const {
  modal: { toggle },
  status: { edit: editStatus },
} = actions.invoice;

export default fp.compose(
  withCreateInvoice(),
  connect(
    mapState(['invoice']),
    { toggle, editStatus }
  )
)(InvoiceModal);



// WEBPACK FOOTER //
// ./src/components/InvoiceModal/InvoiceModal.js